import * as React from "react";

import ReactTable from "react-table";
import { Column } from "react-table";
import "react-table/react-table.css";

import { Container, Button, InputGroup, InputGroupAddon, Input } from "reactstrap";

import "./createorder.css";
import i18n from "../i18n";

import { getAsync } from "utils/net";

export interface CreateOrderTableProps {
}
export interface CreateOrderTableState {
    createOrders: any[];
    quickfind: string;
    loading: boolean;
    selectedItem: any;
    isNew: boolean;
    showExport: boolean;
    showNoNtuple: boolean;
}

export class CreateOrderTable extends React.Component<
    CreateOrderTableProps,
    CreateOrderTableState
> {
    private filterMethod = (filter: any, row: any) =>
        new RegExp(filter.value, "i").test(String(row[filter.id]));

    private columns: Column[] = [
        {
            Header: i18n.CreateOrder.Table.Scenario,
            accessor: "DialogName"
        },
        {
            Header: i18n.CreateOrder.Table.ChosenNtuple,
            accessor: "ChosenNtuple"
        },
        {
            Header: i18n.CreateOrder.Table.ChosenProduct,
            accessor: "ChosenProduct"
        },
        {
            Header: i18n.CreateOrder.Table.BUOwner,
            accessor: "BUOwner"
        },
        {
            Header: i18n.CreateOrder.Table.Type,
            accessor: "Type"
        },
        {
            Header: i18n.CreateOrder.Table.VirtualNode,
            accessor: "VirtualNode"
        },
        {
            Header: i18n.CreateOrder.Table.Cluster,
            accessor: "Cluster"
        },
        {
            Header: i18n.CreateOrder.Table.Market,
            accessor: "Market"
        },
        {
            Header: i18n.CreateOrder.Table.Channels,
            accessor: "Channels"
        },
        {
            Header: i18n.CreateOrder.Table.ServiceType,
            accessor: "ServiceType"
        },
        {
            Header: i18n.CreateOrder.Table.ProductFamilyDescription,
            accessor: "ProductFamily"
        },
        {
            Header: i18n.CreateOrder.Table.ProductDescription,
            accessor: "ProductDescription"
        },
        {
            Header: i18n.CreateOrder.Table.SubProductDescription,
            accessor: "SubProduct"
        },
        {
            Header: i18n.CreateOrder.Table.InvokeReason,
            accessor: "InvokeReason"
        },
        {
            Header: i18n.CreateOrder.Table.DetailDescriptionA,
            accessor: "ProductDetailA"
        },
        {
            Header: i18n.CreateOrder.Table.DetailDescriptionB,
            accessor: "ProductDetailB"
        }
    ];

    private currentView: any;

    constructor(props: CreateOrderTableProps) {
        super(props);
        this.state = {
            selectedItem: null,
            loading: false,
            isNew: false,
            showExport: false,
            createOrders: [],
            quickfind: "",
            showNoNtuple: true
        };
    }
    componentWillMount() {
        this.loadCreateOrders();
    }

    render() {
        return (
            <Container fluid={true} className="scenarios-page page">
                <h1 className="page-header">{i18n.CreateOrder.Title}</h1>
                <p>
                    <Button
                        color="primary"
                        size="sm"
                        onClick={() => this.onDownloadCSVClick()}
                    >
                        {i18n.Scenarios.ExportDialog.ExportButton}
                    </Button>&nbsp;
                    {this.state.showNoNtuple ?
                        <Button
                            color="primary"
                            size="sm"
                            onClick={() => this.toggleEntries(!this.state.showNoNtuple)}
                        >
                            {i18n.CreateOrder.ToggleButton.ToggleButtonWith}
                        </Button>
                        : <Button
                            color="primary"
                            size="sm"
                            onClick={() => this.toggleEntries(!this.state.showNoNtuple)}
                        >
                            {i18n.CreateOrder.ToggleButton.ToggleButtonWithout}
                        </Button>}
                    &nbsp;
                </p>
                <p>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">🔍</InputGroupAddon>
                        <Input placeholder="quick find" onChange={e => this.onQuickFind(e)} />
                    </InputGroup>
                </p>
                <ReactTable
                    noDataText={this.state.loading ? "Loading" : "No items found"}
                    data={this.list}
                    filterable={true}
                    columns={this.columns}
                    defaultFilterMethod={this.filterMethod}
                    defaultPageSize={10}
                    className="-striped -highlight"
                    ref={(r) => {
                        this.currentView = r;
                    }}
                />
            </Container>
        );
    }

    private async loadCreateOrders() {
        this.setState({ loading: true });

        const reply = await getAsync("/api/designer/getcreateorderslist");
        const payload = await reply.json();

        this.setState({
            createOrders: payload,
            loading: false,
        });
    }

    private onQuickFind(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            quickfind: e.target.value,
        })
    }

    private async onDownloadCSVClick(): Promise<void> {

        const currentRecords = this.currentView.getResolvedState().sortedData as Array<any>;

        var BOM = new Uint8Array([0xEF, 0xBB, 0xBF]);

        const separator = ",";
        const keys = this.columns.map(c => { return c.accessor });
        const headers = this.columns.map(c => { return c.Header });
        const csvContent =
            headers.join(separator) +
            "\n" +
            currentRecords.map(row => {
                return keys.map(k => {
                    let cell = k === undefined || row[k.toString()] === null || row[k.toString()] === undefined
                        ? "" : row[k.toString()];
                    cell = cell instanceof Date
                        ? cell.toLocaleString()
                        : cell.toString().replace(/"/g, "");
                    if (cell.search(/("|,|\n)/g) >= 0) {
                        cell = `"${cell}"`;
                    }
                    return cell;
                }).join(separator);
            }).join("\n");

        const url = window.URL.createObjectURL(
            new Blob([BOM, csvContent], { type: "csv;charset=utf8" }));

        const link = document.createElement("a");

        link.href = url;

        link.setAttribute("download", `CreateOrders_${new Date()}.csv`);

        document.body.appendChild(link);

        link.click();
    }

    private isEmptyOrSpaces(str: string) {
        return str === null || str.match(/^ *$/) !== null;
    }

    private toggleEntries(toSet: boolean) {
        this.setState({
            showNoNtuple: toSet
        })
    }

    private get list() {
        const field = "ChosenNtuple";
        const filtered = this.state.createOrders
            .filter(this.state.showNoNtuple
                ? item => this.isEmptyOrSpaces(item[field]) === true
                : item => this.isEmptyOrSpaces(item[field]) === false)
            .filter(this.state.quickfind
                ? item => this.columns.some(
                    col => this.filterMethod({ id: col.accessor, value: this.state.quickfind }, item))
                : item => true);
        return filtered;
    }
}



// WEBPACK FOOTER //
// ./src/createorder/createorder.tsx